import AssignClassDetailsAuthenticated from 'approot/shared/assign/assign-class-details-authenticated';
import AssignClassDetailsUnauthenticated from 'approot/shared/assign/assign-class-details-unauthenticated';
import Bouncer from 'approot/shared/bouncer/bouncer';
import { AssignClassDetailBouncer } from './assign-class-detail-modal.style';
import { useGetClassStudents } from 'approot/students/use-get-class-students';

const AssignClassDetails = () => {
  const { data, loading, hasStudents } = useGetClassStudents();

  if (loading) {
    return (
      <AssignClassDetailBouncer>
        <Bouncer />
      </AssignClassDetailBouncer>
    );
  }

  return hasStudents ? (
    <AssignClassDetailsAuthenticated students={data?.getClassStudents || []} />
  ) : (
    <AssignClassDetailsUnauthenticated />
  );
};

export default AssignClassDetails;
